const FAQ = () => import('@/views/main/helper/faq/FAQLibrary.vue')
export default {
  path: '/main/helper/faq',
  name: 'FAQ',
  component: FAQ,
  children: []
}
